/**
 * Minimal RFC-4180 CSV serialiser + browser download trigger.
 * Used by the admin Enquiries table to export filtered submissions.
 */

const escapeCell = (value) => {
  if (value === null || value === undefined) return "";
  const str = String(value);
  // Quote any cell containing a comma, quote, newline or leading whitespace.
  if (/[",\n\r]|^\s|\s$/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export function rowsToCsv(headers, rows) {
  const headerLine = headers.map(escapeCell).join(",");
  const bodyLines = rows.map((row) => row.map(escapeCell).join(","));
  return [headerLine, ...bodyLines].join("\r\n");
}

export function downloadCsv(filename, csvText) {
  // BOM helps Excel open UTF-8 correctly.
  const blob = new Blob(["\ufeff", csvText], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Defer revoke so Safari finishes the download.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
